import { Image } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLoading } from "../../context/LoadingContext";
import { envChangeType } from "../../plugins/utils";
import { CashReward, InviteArea, TeamDividends } from "./components";
import { useGetShare } from "./hooks/index.hook";
import levelBlack from "./images/level-black.png";
import remuneration from "./images/remuneration.png";
import styles from "./style.module.scss";

const Share = () => {
  const { t } = useTranslation();
  const { setMainLoading } = useLoading();
  const { data, isFetching } = useGetShare();

  const sectionEnum = [
    {
      target: "remuneration",
      disableTitle: true,
      customStyle: styles.remuneration,
    },
    {
      target: "officialWebsite",
      disableTitle: false,
      customStyle: styles.officialWebsite,
    },
    {
      target: "inviteArea",
      disableTitle: false,
      render: (index) => data?.code && <InviteArea data={data} key={index} />,
    },
    {
      target: "levelBlack",
      disableTitle: false,
      render: (index) => (
        <div className={styles.levelBlack} key={index}>
          <Image src={levelBlack} ale="levelBlack" preview={false} className={styles.a} />
        </div>
      ),
    },
    {
      target: "commission",
      disableTitle: false,
      contentStyle: styles.normalContent,
      customStyle: styles.commission,
    },
    {
      target: "cashReward",
      disableTitle: false,
      render: (index) => <CashReward key={index} />,
    },
    {
      target: "teamDividends",
      disableTitle: false,
      render: (index) => <TeamDividends key={index} />,
    },
  ];

  const renderSection = ({
    target,
    contentStyle = styles.content,
    customStyle = "",
    disableTitle = false,
    index,
  }) => {
    return (
      <section className={`${styles.section} ${customStyle}`} key={index}>
        {!disableTitle && <div className={styles.title}>{t(`share.${target}`)}</div>}
        <div
          className={contentStyle}
          dangerouslySetInnerHTML={{
            __html: t(`share.${target}.content`, {
              currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
            }),
          }}
        />
      </section>
    );
  };

  useEffect(() => {
    setMainLoading(isFetching);
  }, [isFetching]);

  useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <div className={styles.share}>
      <div className={styles.vipContainer}>
        <Image
          src={`/images/vip/VIP${data?.level || 0}.png`}
          ale="vip"
          preview={false}
          className={styles.img}
        />
        <div className={styles.data}>
          <div>{t("share.quantity", { quantity: data?.total || 0 })}</div>
          <div>{t("share.vip", { vip: data?.level || 0 })}</div>
        </div>
      </div>
      <div className={styles.imgContainer}>
        <Image
          src={remuneration}
          ale="remuneration"
          preview={false}
          className={styles.remunerationImg}
        />
      </div>
      {sectionEnum.map((item, index) => {
        if (item.render) {
          return item.render(index);
        } else {
          return renderSection({
            index,
            target: item.target,
            disableTitle: item.disableTitle,
            contentStyle: item.contentStyle,
            customStyle: item.customStyle,
          });
        }
      })}
    </div>
  );
};

export default Share;
